import focusInput from "./focusInput.directive";

const focusInputModule = angular
  .module("app.directives.focusInput", [])
  .directive("focusInput", focusInput);

export default focusInputModule;



// WEBPACK FOOTER //
// ./src/directives/focusInput/focusInput.module.js